'use client';

import { useState } from 'react';

import { Order } from '../../types/product';
import CartOrderSummary from '../../ui/CartOrderSummary';
import { CartView } from '../../ui/CartView';

interface CartPageProps {}

const CartPage = ({}: CartPageProps) => {
  const [cartItems, setCartItems] = useState<Order[]>([]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Cart Items - Takes 2 columns on large screens */}
          <div className="lg:col-span-2">
            <CartView onCartUpdate={setCartItems} />
          </div>

          {/* Order Summary - Takes 1 column on large screens */}
          <div className="lg:col-span-1">
            <CartOrderSummary cartItems={cartItems} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
